export const useModal = () => {
  const { isMobileOrTablet } = useDevice();
  const data = useState("gallery", () =>
    shallowRef({
      "production-1": {
        images: [
          "/static/image/production/1-1.jpg",
          "/static/image/production/1-2.jpg",
          "/static/image/production/1-3.jpg",
        ],
      },
      "production-2": {
        images: [
          "/static/image/production/2-1.jpg",
          "/static/image/production/2-2.jpg",
          "/static/image/production/2-3.jpg",
        ],
      },
      "production-3": {
        images: [
          "/static/image/production/3-1.jpg",
          "/static/image/production/3-2.jpg",
          "/static/image/production/3-3.jpg",
        ],
      },
      "production-4": {
        images: [
          "/static/image/production/4-1.jpg",
          "/static/image/production/4-2.jpg",
          "/static/image/production/4-3.jpg",
        ],
        "production-5": {
          images: [
            "/static/image/production/5-1.jpg",
            "/static/image/production/5-2.jpg",
            "/static/image/production/5-3.jpg",
          ],
        },
      },
    })
  );

  const setData = (name, _data) => {
    data.value[name]
      ? Object.assign(data.value[name], _data)
      : (data.value[name] = _data);

    navigateTo({ path: "/_modal", query: { gallery: name } });
  };

  const setIndex = (index) => {
    if (data.value[data.value.current])
      data.value[data.value.current].index = index;
  };

  const getData = async (name) => {
    data.value.current = name;
    if (data.value[name]) return data.value[name];
    try {
      const images = await $fetch("/api/gallery?url=" + name);
      images.forEach((el, i) => (images[i] = `/upload/image/${el}/big.jpg`));
      data.value[name] = { index: 0, images };
      return data.value[name];
    } catch (e) {
      return null;
    }
  };

  const getHtml = async (name) => {
    try {
      return await $fetch("/api/text?url=" + name);
    } catch (e) {
      return null;
    }
  };

  const mVideo = (video, vertical = false) => {
    const query = { video };
    if (vertical) query.vertical = true;
    navigateTo({ path: "/_modal", query });
  };
  const mYoutube = (youtube) =>
    navigateTo({ path: "/_modal", query: { youtube } });

  return {
    isModal: !isMobileOrTablet,
    setData,
    setIndex,
    getData,
    mYoutube,
    mVideo,
    getHtml,
  };
};
